<template>
  <button
    @click="toggle"
    :title="dark ? 'Switch to light mode' : 'Switch to dark mode'"
    class="inline-flex items-center justify-center w-7 h-7 rounded-full bg-white/20 hover:bg-white/30 text-sm transition-colors"
  >{{ dark ? '☀️' : '🌙' }}</button>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const dark = ref(false)

function apply(value) {
  document.documentElement.classList.toggle('dark', value)
  try { localStorage.setItem('speaksaigon_theme', value ? 'dark' : 'light') } catch (e) { /* ignore */ }
  dark.value = value
}

function toggle() { apply(!dark.value) }

onMounted(() => { dark.value = document.documentElement.classList.contains('dark') })
</script>
